import React from 'react';
import Header from '../componets/Header.tsx';
import { Outlet } from 'react-router-dom';

const MainLayout:React.FC = () => {
  return (
    <div className="wrapper">
      <Header />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
